import React from 'react';
import { useEffect, useState } from 'react'
import axios from "axios";
import { useTranslation,Trans  } from 'react-i18next';
import { endPoints } from "../../Constants";
import { Link } from 'react-router-dom';

const News = () => {
  const { t,i18n } = useTranslation();
    const [myMedia, setMedia] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem('token');

        axios
            .get(`${endPoints.news}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                // Limit to the first 3 items
                const limitedMedia = res.data.slice(0, 3);
                setMedia(limitedMedia);
                // console.log('Limited Media:', limitedMedia); // Correctly logs the fetched limited data
            })
            .catch((err) => {
                console.error('Error fetching data:', err);
            });
    }, []);

    // Handle Explore More Click Based on `readMoreAction`
    const handleExploreClick = (e, action, content) => {
        e.preventDefault();

        if (!content) return;

        switch (action) {
            case 'Link':
                // Open URL in a new tab
                window.open(content, '_blank');
                break;

            case 'File':
                // Open PDF or file in a popup
                window.open(content, '_blank', 'width=800,height=600');
                break;

            case 'Text':
                // Open Text Content in a popup
                const popup = window.open('', '_blank', 'width=600,height=400');
                popup.document.write(`<pre>${content}</pre>`);
                popup.document.title = 'Content Preview';
                break;

            default:
                console.warn('Unsupported readMoreAction:', action);
        }
    };
    return (
        <>
            <section className='lyt-section typ-news-sec' id='grsfnews'>
                <div className='container'>
                    <div className='heading-wrapper'>
                        <div>
                            <h2 className='bs-heading typdblue mb-2' data-aos="fade-in" data-aos-delay="200">{t('newsTitle')}</h2>
                            <p className='bs-para typgrey' data-aos="fade-in" data-aos-delay="300">{t('newsDesc')}</p>
                        </div>

                        <Link className="bs-btn" to="/media" aria-label="Navigate to Contact Us page" data-aos="fade-in" data-aos-delay="200">
                            {t('viewAll')} <span className="icon icon-right-arrow"></span>
                        </Link>
                    </div>

                    <div className='row'>
                        <div className='col-lg-7 col-12'>
                            <div className='leftBox'>
                                {myMedia.length > 0 && (
                                    <div className='bs-card typ-news' data-aos="fade-in" data-aos-delay="200">
                                        <div className='box-img'>
                                            <img
                                                className="img-fluid"
                                                src={
                                                    myMedia[0].newsMediaImageURL
                                                }
                                                alt="logo"
                                                width={384}
                                                height={437}
                                            />
                                        </div>
                                        <div className='box-text'>
                                            <div className='title'>{ i18n.language === 'mr' ? myMedia[0].newsMediaShortDesMr : myMedia[0].newsMediaShortDes }</div>
                                            <div className='discription'>
                                                { i18n.language === 'mr' ? myMedia[0].newsMediaLongDesMr : myMedia[0].newsMediaLongDes }
                                            </div>
                                            <div className='new-flex mob-new-flex'>
                                                <div>
                                                    <div className='date'>{myMedia[0].newsMediaDate}</div>
                                                    <div className='publish'>{myMedia[0].newsMediaPublishedBy}</div>
                                                </div>
                                                <div className='text-align'>
                                                    <a className="bs-btn typfill"
                                                        // href={myMedia[0].readMoreContent}
                                                        href={myMedia[0].readMoreContent || '#'}
                                                        onClick={(e) => handleExploreClick(e, myMedia[0].readMoreAction, myMedia[0].readMoreContent)}
                                                        aria-label="Navigate to Contact Us page">
                                                        {t('exploreMore')} <span className="icon icon-right-arrow"></span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='col-lg-5 col-12 mt-lg-0 mt-4'>
                            <div className='rightBox'>
                                <div className='row'>


                                    <div className='col-12'>

                                        {myMedia.slice(1).map((item, index) => {
                                            debugger;
                                            const { newsMediaShortDes,newsMediaShortDesMr, newsMediaLongDes,newsMediaLongDesMr, newsMediaDate, newsMediaPublishedBy,newsMediaPublishedByMr, newsMediaImageURL, readMoreAction, readMoreContent } = item
                                            const NewsMediaShortDes = i18n.language === 'mr' ? newsMediaShortDesMr : newsMediaShortDes;
                                            // const formattedDate = new Intl.DateTimeFormat(i18n.language === 'mr' ? 'mr-IN' : 'en-IN', {
                                            //                         year: 'numeric',
                                            //                         month: 'long',
                                            //                         day: 'numeric',
                                            //                         weekday: 'long'
                                            //                         }).format(new Date(newsMediaDate));
                                            return (
                                                <div className='inner-left' key={index} data-aos="fade-in" data-aos-delay="300">
                                                    <div className='bs-card typ-news'>
                                                        <div className='box-img'>
                                                            <img
                                                                className="img-fluid"
                                                                src={newsMediaImageURL}
                                                                alt="logo"
                                                                width={384}
                                                                height={297}
                                                            />
                                                        </div>
                                                        <div className='box-text'>
                                                            <div className='title'>{NewsMediaShortDes}</div>

                                                            <div className='new-flex'>
                                                                <div>
                                                                    <div className='date'>{newsMediaDate}</div>
                                                                </div>
                                                                <a className="bs-btn typexplore"
                                                                    href={readMoreContent || '#'}
                                                                    onClick={(e) => handleExploreClick(e, readMoreAction, readMoreContent)}
                                                                    aria-label="Navigate to Contact Us page">
                                                                    {t('exploreMore')}  <span className="icon icon-right-arrow"></span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}



                                        {/* <div className='inner-right mt-4' data-aos="fade-in">
                                            <div className='bs-card typ-news'>
                                                <div className='box-img'>
                                                    <img
                                                        className="img-fluid"
                                                        src="/images/home/news/3.jpg"
                                                        alt="logo"
                                                        width={384}
                                                        height={297}
                                                    />
                                                </div>
                                                <div className='box-text'>
                                                    <div className='title'>Redevelopment Made Accessible: GRSF Advocates for Premium Reductions to Ease Housing Costs</div>
                                                    <div className='new-flex'>
                                                        <div>
                                                            <div className='date'>28th Feb, 2025</div>
                                                        </div>
                                                        <a className="bs-btn typexplore" href="" aria-label="Navigate to Contact Us page">
                                                            Explore More <span className="icon icon-right-arrow"></span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default News;
